import {  init } from '@web3-onboard/react';
import injectedModule, { ProviderLabel } from '@web3-onboard/injected-wallets';
import Onboard from '@web3-onboard/core'

/* Extra Wallets */
import coinbaseWalletModule from '@web3-onboard/coinbase'
import walletConnectModule from '@web3-onboard/walletconnect'

const coinbaseWalletSdk = coinbaseWalletModule()
const wcInitOptions = {
  projectId: 'e97dee99dae3b04bddd9504fbb177447',

  requiredChains: [11155111],

  optionalChains: [11155111],

  dappUrl: 'https://domain.com'
}

const walletConnect = walletConnectModule(wcInitOptions)


const INFURA_KEY = "ee05f4632b484d3b8386b334555be62a";
export const INFURA_URL = `https://mainnet.infura.io/v3/${INFURA_KEY}`;

const BLOCKNATIVE_API_KEY = process.env.REACT_APP_BLOCKNATIVE_API_KEY;

const injected = injectedModule({
  filter: {
    [ProviderLabel.Phantom]: false
  }
})

const wallets = [
  injected,
  coinbaseWalletSdk,
  walletConnect
];

const chains = [
  {
    id: '0x1',
    token: 'ETH',
    label: 'Ethereum Mainnet',
    rpcUrl: `https://mainnet.infura.io/v3/${INFURA_KEY}`
  },
  /*
  {
    id: '0xaa36a7',
    token: 'ETH',
    label: 'Sepolia Testnet',
    rpcUrl: `https://sepolia.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`
  },
  */
];

export const Web3Onboard = init({
  connect: {
    autoConnectAllPreviousWallet: true,
  },
  accountCenter: {
    desktop: {
      position: 'bottomRight',
      enabled: true,
      minimal: true,
    },
    mobile: {
      position: 'bottomRight',
      enabled: false,
      minimal: false,
    }
  },
  notify: {
    desktop: {
      enabled: true,
      transactionHandler: transaction => {
        console.log({ transaction })
        if (transaction.eventCode === 'txPool') {
          return {
            type: 'success',
            message: 'Your transaction from #1 DApp is in the mempool',
          }
        }
      },
      position: 'bottomLeft'
    },
    mobile: {
      enabled: true,
      transactionHandler: transaction => {
        console.log({ transaction })
        if (transaction.eventCode === 'txPool') {
          return {
            type: 'success',
            message: 'Your transaction from #1 DApp is in the mempool',
          }
        }
      },
      position: 'topRight'
    }
  },
  appMetadata: {
    name: "Storme Token Staking", // change to your dApp name
    description: "Staking dapp for Storme Token",
    icon: "https://storme-presale.netlify.app/assets/logo-full-9d5c0490.png",
    logo: "https://storme-presale.netlify.app/assets/logo-full-9d5c0490.png",
    recommendedInjectedWallets: [
      { name: 'MetaMask', url: 'https://metamask.io' },
      { name: 'Coinbase', url: 'https://wallet.coinbase.com/' }
    ],
    explore: 'https://storme.io/'
  },
  apiKey: BLOCKNATIVE_API_KEY,
  wallets,
  chains,
  theme: 'dark',
  i18n: {
    en: {
      connect: {
        selectingWallet: {
          header: 'custom text header'
        }
      },
      notify: {
        transaction: {
          txStuck: 'custom text for this notification event'
        },
        watched: {
          // Any words in brackets can be re-ordered or removed to fit your dapps desired verbiage
          "txPool": "Your account is {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}"
        }
      }
    },
    es: {
      transaction: {
        txRequest: 'Su transacción está esperando que confirme'
      }
    }
  },
});